import React from 'react';

const DisplayValue = ({ value }: { value: string | number }) => <>{value === 0 ? null : value}</>;

export default DisplayValue;
